import { AgeCategory } from '../../../models/AgeCategory';

export const AGE_CHANGE = 'AGE_CHANGE';

export interface AgeCategoryAction {
    type: typeof AGE_CHANGE;
    payload: AgeCategory;
}
